module.exports = __webpack_public_path__ + "img/ssc.ff2eba64.jpg";